import { useState } from 'react';
import { useAuth, usePrincipal } from '@/lib/auth/use-auth';
import { toPrincipal, usePrincipalSearch } from '@/lib/directory/use-principal-search';
import { Button, FormField, LookupField, Select, toast, type LookupOption } from '@/lib/ui';
import { ACCOUNT_TEAM_ROLES, type AccountTeamRole, type Company } from '@shared/types';
import { addTeamMember, removeTeamMember } from './api';

const LABEL: Record<AccountTeamRole, string> = { account_manager: 'Account manager', support_agent: 'Support agent', field_tech: 'Field technician', ai_agent: 'AI agent' };

export function AccountTeamTab({ company }: { company: Company }) {
  const { role } = useAuth();
  const me = usePrincipal();
  const search = usePrincipalSearch({ includeAgents: true });
  const [who, setWho] = useState<LookupOption | null>(null);
  const [teamRole, setTeamRole] = useState<AccountTeamRole>('support_agent');
  const add = async () => {
    if (!who) return;
    const principal = toPrincipal(who);
    try {
      await addTeamMember(company, { principal, role: principal.type === 'agent' ? 'ai_agent' : teamRole }, me);
      toast.success(`${principal.name} added`);
      setWho(null);
    } catch (e) {
      toast.error(e instanceof Error ? e.message : 'Failed');
    }
  };
  return (
    <div className="card">
      <div className="card-header"><span className="card-title">Account team ({company.accountTeam.length})</span></div>
      <div className="card-body">
        {company.accountTeam.length === 0 ? <div className="empty-state">No one is assigned to this account yet.</div> : company.accountTeam.map((m) => (
          <div key={m.principal.id} className="settings-row">
            <div><strong>{m.principal.name}</strong>{m.principal.type === 'agent' ? <> <span className="badge badge-green">AI</span></> : null}<div className="settings-desc">{LABEL[m.role]}</div></div>
            {role === 'admin' ? <Button size="sm" variant="ghost" onClick={() => removeTeamMember(company, m.principal.id, me)}>Remove</Button> : null}
          </div>
        ))}
        {role === 'admin' ? (
          <div style={{ marginTop: 12 }}>
            <FormField label="Add a person or AI agent" htmlFor="team-who"><LookupField id="team-who" value={who} onChange={setWho} search={search} placeholder="Search people or AI agents…" /></FormField>
            <FormField label="Team role" htmlFor="team-role"><Select id="team-role" value={teamRole} onChange={(e) => setTeamRole(e.target.value as AccountTeamRole)} options={ACCOUNT_TEAM_ROLES.map((r) => ({ value: r, label: LABEL[r] }))} /></FormField>
            <Button variant="primary" disabled={!who} onClick={add}>Add to team</Button>
          </div>
        ) : null}
      </div>
    </div>
  );
}
